module.exports = __webpack_public_path__ + "assets/615b36805dc0b3014d12b1cb29bf362a.jpg";